<template>
  <div class="landingPageResule">
    <div class="downloadApp" @click="handleDownload">下载APP</div>
    <div class="browserOpen" @click="handleClick">浏览器打开</div>
  </div>
</template>

<script>
import { getLatestVersion, getSysConfigByKey } from "@/api/index.js";
import { getDeviceOS } from "@/common/index";
export default {
  name: "LandingPageResule",
  components: {},
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    openDownloadLink(url) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      // 如果是文件下载可以加上 download 属性
      // link.setAttribute('download', 'filename');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async handleDownload() {
      const os = getDeviceOS();
      if (os === "ios") {
        const res = await getLatestVersion({
          versionChannel: "official_ios",
        });
        this.openDownloadLink(res.data.downloadUrl);
      } else if (os === "android") {
        const res = await getLatestVersion({
          versionChannel: "official_android",
        });
        this.openDownloadLink(res.data.downloadUrl);
      } else {
        this.$toast("请在移动端打开");
      }
    },
    async handleClick() {
      const res = await getSysConfigByKey("h5_link");
      window.location.href = res.data.configValue;
    },
  },
};
</script>

<style scoped lang="scss">
.landingPageResule {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-image: url("@/assets/style/phone-model-icon.png");
  background-size: 100% 100%;
  background-position: center;
}
.downloadApp {
  position: absolute;
  top: 36%;
  right: 0;
  font-size: 15px;
  color: #1d70f7;
  background-image: url("@/assets/style/loading-btn.png");
  background-size: cover;
  background-position: center;
  width: 140px;
  padding: 12px 0px;
  text-align: center;
}
.browserOpen {
  position: absolute;
  top: 50%;
  right: 0;
  font-size: 15px;
  color: #1d70f7;
  background-image: url("@/assets/style/loading-btn.png");
  background-size: cover;
  background-position: center;
  width: 140px;
  padding: 12px 0px;
  text-align: center;
}
</style>
